module.exports = __webpack_public_path__ + "static/media/Receptionist1.1aa7dd10.jpg";